import React from 'react';
import PropTypes from 'prop-types';

import { getThumbBySize } from '../../../../../../util/photo';
import { IMAGE_SIZE_CODE } from '../../../../../../constants/image-size-codes';
import HeadOpenGraphMeta from '../../../../../../components/global/HeadOpenGraphMeta';

const propTypes = {
  hierarchyItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

const SelfieRequestLinkHandlerHeadMeta = ({ hierarchyItem }) => {
  const rootAlbumFolder =
    hierarchyItem?.album?.root_album_folder ??
    hierarchyItem?.album_folder?.root;

  const coverPhoto =
    rootAlbumFolder?.cover_photo ?? rootAlbumFolder?.cover_photos?.records?.[0];

  const imageUrl = getThumbBySize(
    coverPhoto?.thumbnail_urls,
    IMAGE_SIZE_CODE.MEDIUM2X,
  )?.url;

  return (
    <HeadOpenGraphMeta
      title={`Add your selfie - ${rootAlbumFolder?.name}`}
      imageUrl={imageUrl}
    />
  );
};

SelfieRequestLinkHandlerHeadMeta.propTypes = propTypes;

export default SelfieRequestLinkHandlerHeadMeta;
